module.exports = __webpack_public_path__ + "static/media/vmoda-xs.1f73d960.jpg";